import { render, staticRenderFns } from "./SupportCaseDetail.vue?vue&type=template&id=52180f73&scoped=true"
import script from "./SupportCaseDetail.vue?vue&type=script&lang=js"
export * from "./SupportCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportCaseDetail.vue?vue&type=style&index=0&id=52180f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52180f73",
  null
  
)

export default component.exports